import { useProductAdvisor } from "../../../components/feature/ProductAdvisor";

export default function ProductAdvisorCTA() {
  const { open } = useProductAdvisor();

  return (
    <section className="py-14 md:py-20 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-emerald-accent/10 border border-emerald-accent/20 flex-shrink-0">
              <i className="ri-compass-3-line text-3xl text-emerald-accent" />
            </div>
            <div className="text-center md:text-left flex-1">
              <h2 className="text-xl md:text-2xl font-bold text-white mb-2">
                Not Sure Which Solution You Need?
              </h2>
              <p className="text-sm md:text-base text-silver-300 leading-relaxed mb-5">
                Our Product Advisor analyses your business needs and recommends the right fit from across all 11 StackMap BOS modules, our standalone OMS platform, or our vertical SaaS products, or suggests a bespoke solution if that's the better path — all in under 60 seconds.
              </p>
              <button
                onClick={open}
                className="btn-primary inline-flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-compass-3-line text-sm" />
                Start Product Advisor
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
